const SvgIcons = {};

const build = () => {
    const modules = import.meta.glob('./**/*.svg', { eager: true, query: '?react', import: 'default' });
    Object.keys(modules).forEach(function(key) {
        const [iconName] = key.split('/').slice(-1);
        const [name] = iconName.split('.');
        SvgIcons[name] = modules[key];
    });
};

build();

export default SvgIcons;
